import PollsAdminTemplate from "components/templates/PollsAdminTemplate/PollsAdminTemplate";

const PollsPage = () => {
  return <PollsAdminTemplate />;
};

export default PollsPage;
